import axios from 'axios';
import { LOGIN_TOKEN_COOKIE_NAME, authActions } from '@store/auth';
import { showErrorMessage } from '@store/dashboard';

const BASE_URL = process.env.REACT_APP_API_URL;
const ROOT_PREFIX = '/api/v1';
const DASHBOARD_PREFIX = `${ROOT_PREFIX}/dashboard`;
const DEEPLINK_URL = process.env.REACT_APP_DEEPLINK_API_URL;

export const NO_PERMISSION_MESSAGE =
  'You do not have permission to perform this action.';

let store;

export const injectStore = (_store) => {
  store = _store;
};

const getCookie = (cname) => {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

const rootAPI = axios.create({
  baseURL: BASE_URL + ROOT_PREFIX,
});

const dashboardAPI = axios.create({
  baseURL: BASE_URL + DASHBOARD_PREFIX,
});

const deeplinkApi = axios.create({
  baseURL: DEEPLINK_URL,
});

dashboardAPI.interceptors.request.use(
  (config) => {
    const token = getCookie(LOGIN_TOKEN_COOKIE_NAME);

    if (token && !config.noHeader) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }

    // eslint-disable-next-line no-promise-executor-return
    return new Promise((resolve) => setTimeout(() => resolve(config), 1));
  },
  (error) => Promise.reject(error),
);

dashboardAPI.interceptors.response.use(
  (response) => response,

  // eslint-disable-next-line consistent-return
  (error) => {
    const { bypassAutoLogout = false } = error.config || {};
    const { status } = error.response || {};

    if (status === 401) {
      // eslint-disable-next-line no-console
      console.error('Expired or Unauthorized Dashboard Token');

      if (!bypassAutoLogout) {
        store.dispatch(authActions.logout());
      }
    }

    if (status === 403 && !bypassAutoLogout) {
      if (getCookie(LOGIN_TOKEN_COOKIE_NAME)) {
        store.dispatch(
          showErrorMessage({
            message: NO_PERMISSION_MESSAGE,
            duration: 5000,
          }),
        );
      } else {
        store.dispatch(authActions.logout());
      }
    }

    return Promise.reject(error);
  },
);

export { rootAPI, dashboardAPI, deeplinkApi };
